import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { darkGrayFontColor } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	dropdownAnchor: {
		width: 260,
	},
	searchEmployeeBox: {
		fontSize: 14,
		marginTop: 16,
	},
	// "Pending" status pill shown on not-yet-activated employees in the picker.
	pendingBadge: {
		display: 'inline-block',
		marginRight: 6,
		paddingTop: 1,
		paddingBottom: 1,
		paddingLeft: 6,
		paddingRight: 6,
		borderRadius: 4,
		backgroundColor: THEME.colors.warning.light,
		color: THEME.colors.warning.main,
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: 'bold',
		// line-height accepts unitless multipliers, so Aphrodite won't append px — keep the unit explicit.
		lineHeight: '14px',
	},
	sendFromDropdownContainer: {
		alignItems: 'center',
		color: darkGrayFontColor,
		display: 'flex',
		fontSize: 14,
		width: '100%',
		gap: 8,
	},
	popoverStyles: {
		zIndex: 51,
	},
	reconnectHint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
});
